import { render, staticRenderFns } from "./sigin.vue?vue&type=template&id=3810f3ba&scoped=true&"
import script from "./sigin.vue?vue&type=script&lang=js&"
export * from "./sigin.vue?vue&type=script&lang=js&"
import style0 from "./sigin.vue?vue&type=style&index=0&id=3810f3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810f3ba",
  null
  
)

export default component.exports